import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import Icon from '../../../components/Icon';
import Geoloc from './Geoloc';
import {Button} from "../../../components/Button";
import {Range} from "rc-slider";
import {config} from "../../../../config";
import {CheckboxInputField} from "../../../components/FormField";
import {fetchLocationSearchCities, resetLocationCities} from "../../../../creators/locations.cities";
import CtaCannot from "../../../components/CtaCannot";

class MeetHeader extends React.Component {
    constructor(props) {
        super(props);

        this.moreFilter = [
            {_id: 'isCertified', name: 'certifié(e)(s)'},
            {_id: 'hasPhotos', name: 'avec photos'},
            {_id: 'hasVideos', name: 'avec vidéos'},
            {_id : 'isOnline', name : "Profils en ligne"}
        ];

        this.marksTrancheAge = {
            0 : '18 ans',
            1 : '25 ans',
            2 : '30 ans',
            3 : '35 ans',
            4 : '40 ans',
            5 : '45 ans',
            6 : '50 ans',
            7 : '55 ans',
            8 : '60 ans +'
        }

        let city = localStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_city`) || null;

        if(city){
            city = JSON.parse(city);
        }
        else{
            city = {};
        }
        this.state = {
            city : city ? {...city} : {_id : null, name : "", parentTypeId : {}, longitude : 0, latitude : 0},
            filter : this.props.usersFilter,
            filterSubMenu: 0
        };

        this.handleToggle = this.handleToggle.bind(this);
        //this.updateAgeValuesOne = this.updateAgeValuesOne.bind(this);
        //this.updateAgeValuesTwo = this.updateAgeValuesTwo.bind(this);
        this.updateTrancheAgeValuesOne = this.updateTrancheAgeValuesOne.bind(this);
        this.updateTrancheAgeValuesTwo = this.updateTrancheAgeValuesTwo.bind(this);
        this.resetTrancheAge = this.resetTrancheAge.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.doubleToggleTag = this.doubleToggleTag.bind(this);
        this.handleLookingFor = this.handleLookingFor.bind(this);
        this.handleCheckbox = this.handleCheckbox.bind(this);
        //this.handleLocation = this.handleLocation.bind(this);
        this.handleLocationDistance = this.handleLocationDistance.bind(this);
        this.handleLocationSwitch = this.handleLocationSwitch.bind(this);
        this.handleLocationCity = this.handleLocationCity.bind(this);
        this.resetTagOption = this.resetTagOption.bind(this);
    }


    componentWillUnmount() {
        this.props.resetLocationCities();
    }


    handleLookingFor(id) {
        let lookingFor = this.state.filter.lookingFor;
        if (lookingFor.includes(id)) {
            lookingFor = lookingFor.filter(item => item !== id);
        } else {
            lookingFor.push(id);
        }
        this.setState({lookingFor});
    }

    handleToggle(key, value) {
        this.setState({[key]: value});
    }

    handleCheckbox(name, id) {
        let stateName = this.state.filter[name];
        if (stateName.includes(id)) {
            stateName = stateName.filter(item => item !== id);
        } else {
            stateName.push(id);
        }
        let filter = {...this.state.filter, [name]: stateName};
        this.setState({filter});
    }

    doubleToggleTag(currentIndex) {
        let currentValue = this.state.filterSubMenu;
        if(currentValue !== currentIndex){
            this.handleToggle("filterSubMenu", currentIndex);
            this.props.handleToggleFilters(true);
        }
        else{
            this.props.handleToggleFilters(false);
        }
    }

    handleOptionTags(name, value) {
        this.setState({filter: {...this.state.filter, [name]: value}})
    }
/*
    updateAgeValuesOne(value) {
        this.setState({filter: {...this.state.filter, ageMinOne: value[0], ageMaxOne: value[1]}});
    }

    updateAgeValuesTwo(value) {
        this.setState({filter: {...this.state.filter, ageMinTwo: value[0], ageMaxTwo: value[1]}});
    }*/

    updateTrancheAgeValuesOne(value) {
        this.setState({filter: {...this.state.filter, trancheAgeMinOne: value[0], trancheAgeMaxOne: value[1]}});
    }
    updateTrancheAgeValuesTwo(value) {
        this.setState({filter: {...this.state.filter, trancheAgeMinTwo: value[0], trancheAgeMaxTwo: value[1]}});
    }

    resetTrancheAge(){
        this.setState({filter: {...this.state.filter, trancheAgeMinTwo: 0, trancheAgeMaxTwo: 8, trancheAgeMinOne: 0, trancheAgeMaxOne: 8}});
    }


    handleLocationDistance(value) {
        this.setState({filter: {...this.state.filter, locationDistance: value}});
    }

    handleLocationCity(city, locationDistance = 125) {
        let filter = {...this.state.filter, longitude: city._id ? city.coordinate.coordinates[0] : 0, latitude: city._id ? city.coordinate.coordinates[1] : 0, locationDistance : locationDistance === 125 && city._id ? 100 : locationDistance};
        this.setState({filter, city : {_id : city._id, name : city.name, parentTypeId : city.parentTypeId, longitude: filter.longitude, latitude: filter.latitude}});
        //this.setState({filter: {...this.state.filter}});
    }

    handleLocationSwitch(datas) {
        this.setState({filter: {...this.state.filter, ...datas}})
    }

    onSubmit() {
        let city = null;
        if(this.state.city._id){
            city = JSON.stringify({
                _id : this.state.city._id,
                name : this.state.city.name,
                parentTypeId : {
                    name : this.state.city.parentTypeId.name
                },
                longitude : this.state.city.longitude,
                latitude : this.state.city.latitude
            })
        }

        localStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_city`, city);

        this.props.onSubmit(this.state.filter);
    }

    isOptionTag(){
        let isOption = false;
        this.moreFilter.forEach(item =>{
            if(this.state.filter[item._id] === true){
                isOption = true;
            }
        })
        return isOption;
    }

    resetTagOption(){
        let filter = {...this.state.filter};
        this.moreFilter.forEach(item =>{
            if(filter[item._id] === true){
                filter[item._id] = false;
            }
        });
        this.setState({filter});
    }

    render() {

        return (
            <div className="meet-filter-timeline">
                <div className={`row wrap meet-tag-container ${this.props.toggleFilters ? 'active' : ''}`}>
                    {this.state.filter.lookingFor && this.state.filter.lookingFor.length > 0 && (
                        <div className="meet-tag primary-reverse"><span className="name"
                                                        onClick={() => this.doubleToggleTag(0)}>Je recherche</span>
                            <span className="meet-close-tag" onClick={() => this.setState({lookingFor: []})}>
                                <Icon type="close" className={"btn-icon-right"}/>
                            </span></div>)}

                    {this.state.filter.locationDistance !== 125 && (
                        <div className="meet-tag primary-reverse"><span className="name"
                                                                        onClick={() => this.doubleToggleTag(0)}>Localisation</span>
                            <span className="meet-close-tag" onClick={() => this.setState({filter : {...this.state.filter, locationDistance: 125}})}>
                                <Icon type="close" className={"btn-icon-right"}/>
                            </span></div>)}

                    {(this.state.filter.trancheAgeMinOne !== 0 || this.state.filter.trancheAgeMaxOne !== 8 || this.state.filter.trancheAgeMinTwo !== 0 || this.state.filter.trancheAgeMaxTwo !== 8) && (
                        <div className="meet-tag primary-reverse">
                            <span className="name" onClick={() => this.doubleToggleTag(3)}>Age</span>
                            <span className="meet-close-tag" onClick={() => this.resetTrancheAge()}><Icon type="close" className={"btn-icon-right"}/></span>
                        </div>
                    )}

                    {this.isOptionTag() && (
                        <div className="meet-tag primary-reverse"><span className="name"
                                                        onClick={() => this.doubleToggleTag(3)}>Autres</span> <span
                            className="meet-close-tag" onClick={() => this.resetTagOption()}><Icon
                            type="close" className={"btn-icon-right"}/></span></div>)}
                </div>
                <div className={`wrapper ${this.props.toggleFilters ? 'active' : ''}`}>
                    <div className="container">
                        <ul className="meet-filter">
                            <li className={this.state.filterSubMenu === 0 ? 'active' : ''}
                                onClick={() => this.handleToggle("filterSubMenu", 0)}>Je recherche
                            </li>
                            {/*<li className={this.state.filterSubMenu == 1 ? 'active' : ''}*/}
                            {/*onClick={() => this.handleToggle("filterSubMenu", 1)}>Type de rencontre*/}
                            {/*</li>*/}
                            <li className={this.state.filterSubMenu === 2 ? 'active' : ''}
                                onClick={() => this.handleToggle("filterSubMenu", 2)}>Localisation
                            </li>
                            <li className={this.state.filterSubMenu === 3 ? 'active' : ''}
                                onClick={() => this.handleToggle("filterSubMenu", 3)}>Plus de précisions
                            </li>
                        </ul>
                        <div className={`meet-filter-block ${this.state.filterSubMenu === 0 ? 'active' : ''}`}>
                            <div className={"row wrap "}>
                                {config.lookingFor.map((name, lookingForIndex) => {
                                    if (lookingForIndex > 0) {
                                        // console.log(lookingForIndex,this.state.filter.lookingFor);
                                        return (
                                            <CheckboxInputField
                                                checked={this.state.filter.lookingFor.includes(lookingForIndex)}
                                                onChange={() => this.handleCheckbox("lookingFor", lookingForIndex)}
                                                htmlFor={`lookingFor_${lookingForIndex}`}
                                                id={`lookingFor_${lookingForIndex}`}
                                                label={name}
                                                key={lookingForIndex}/>
                                        )
                                    } else return null;
                                })}
                            </div>
                        </div>
                        <div className={`meet-filter-block ${this.state.filterSubMenu === 2 ? 'active' : ''}`}>
                            <Geoloc
                                //countries={this.props.countries}
                                //regions={this.props.regions}
                                //counties={this.props.counties}
                                cities={this.props.cities}
                                location={this.state.location}
                                locationDistance={parseInt(this.state.filter.locationDistance)}

                                //handleLocation={this.handleLocation}
                                handleLocationDistance={this.handleLocationDistance}
                                handleLocationSwitch={this.handleLocationSwitch}

                                latitude={this.state.filter.latitude}
                                longitude={this.state.filter.longitude}
                                isUsingGeo={this.state.filter.isUsingGeo}
                                currentCity={this.state.city}
                                fetchLocationSearchCities={this.props.fetchLocationSearchCities}
                                handleLocationCity={this.handleLocationCity}
                            />
                        </div>
                        <div className={`meet-filter-block ${this.state.filterSubMenu === 3 ? 'active' : ''}`}>
                            <div className="meet-sub-block">
                                <h6><Icon type="cog"/>Qui est</h6>
                                {this.moreFilter.map(item => (
                                    <CheckboxInputField checked={this.state.filter[item._id]}
                                                        onChange={() => this.handleOptionTags(item._id, !this.state.filter[item._id])}
                                                        htmlFor={item._id}
                                                        id={item._id}
                                                        label={item.name}
                                                        className={"checkbox-preci"}
                                                        key={item._id}/>
                                ))}
                            </div>

                            <div className="meet-sub-block age-sub-block">
                                {/*<h6><Icon type="age"/>Qui a entre&nbsp;
                                    {this.state.filter.lookingFor.includes(7) || this.state.filter.lookingFor.includes(8) || this.state.filter.lookingFor.includes(9) ? (
                                        <Fragment>
                                            {this.state.filter.ageMinOne} et {this.state.filter.ageMaxOne} ans &nbsp;-&nbsp; {this.state.filter.ageMinTwo} et {this.state.filter.ageMaxTwo} ans
                                        </Fragment>
                                    ) : (
                                        <Fragment>{this.state.filter.ageMinOne} et {this.state.filter.ageMaxOne} ans</Fragment>
                                    )}
                                </h6>*/}
                                {this.state.filter.lookingFor.includes(7) || this.state.filter.lookingFor.includes(8) || this.state.filter.lookingFor.includes(9) ? (
                                    <div className="slider-container">
                                        <div className="age-title">Age 1</div>
                                        <Range
                                            min={0}
                                            max={8}
                                            step={null}
                                            marks={this.marksTrancheAge}
                                            defaultValue={[this.state.filter.trancheAgeMinOne, this.state.filter.trancheAgeMaxOne]}
                                            value={[this.state.filter.trancheAgeMinOne, this.state.filter.trancheAgeMaxOne]}
                                            onChange={this.updateTrancheAgeValuesOne}
                                        />
                                        <div className="age-title">Age 2</div>
                                        <Range
                                            min={0}
                                            max={8}
                                            step={null}
                                            marks={this.marksTrancheAge}
                                            defaultValue={[this.state.filter.trancheAgeMinTwo, this.state.filter.trancheAgeMaxTwo]}
                                            value={[this.state.filter.trancheAgeMinTwo, this.state.filter.trancheAgeMaxTwo]}
                                            onChange={this.updateTrancheAgeValuesTwo}
                                        />
                                    </div>
                                ) : (
                                    <div className="slider-container">
                                        <Range
                                            min={0}
                                            max={8}
                                            step={null}
                                            marks={this.marksTrancheAge}
                                            defaultValue={[this.state.filter.trancheAgeMinOne, this.state.filter.trancheAgeMaxOne]}
                                            value={[this.state.filter.trancheAgeMinOne, this.state.filter.trancheAgeMaxOne]}
                                            onChange={this.updateTrancheAgeValuesOne}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="row full align-center justify-end">
                        <Button className="mr-16"
                                size={"medium"}
                                btnStyle={"grey"}
                                onClick={() => this.props.handleToggleFilters()}
                                content={"Annuler"}/>
                        {this.props.currentUserInitialized ? (
                            <Button size={"medium"}
                                    btnStyle={"primary-reverse"}
                                    onClick={() => this.onSubmit()}
                                    content={"Rechercher"}/>
                        ) : (
                            <CtaCannot action={"meetSearch"} isModal={true} button={{content : "Rechercher"}} />
                        )}

                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        genderList: state.user.genderList,
        genderClass: state.user.genderClass,
        genderOrientation: state.user.genderOrientation,
        dating: state.dating,

        /*countries: state.locationCountries.data,
        regions: state.locationRegions.data,
        counties: state.locationCounties.data,*/
        cities: state.locationCities.data,
        citiesInitialized: state.locationCities.initialized,

        currentUser : state.currentUser.data,
        currentUserInitialized : state.currentUser.initialized

    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({

    resetLocationCities,
    fetchLocationSearchCities
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps, null, {forwardRef: true})(MeetHeader);
